import React from 'react';

export const CodiIcon = ({ fill = 'currentColor', width = 20, height = 24, className }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    viewBox='7 9 28 25'
    fill='none'
    className={className}
    data-codi-icon='true'
    style={{ fill: 'none' }}>
    <path
      d='M29.0887 12.4549L26.6333 13.6828L29.0887 14.9108L30.3167 17.3662L31.5446 14.9108L34 13.6828L31.5446 12.4549L30.3167 9.99951L29.0887 12.4549Z'
      fill='none'
      stroke={fill}
      strokeWidth='0.869668'
      strokeLinecap='round'
      strokeLinejoin='round'
      style={{ fill: 'none' }}
    />
    <path
      d='M14.7884 19.3877L8 22.7827L14.7884 26.1777L18.1833 32.966L21.5783 26.1777L28.3667 22.7827L21.5783 19.3877L18.1833 12.5994L14.7884 19.3877Z'
      fill='none'
      stroke={fill}
      strokeWidth='1.625'
      strokeLinecap='round'
      strokeLinejoin='round'
      style={{ fill: 'none' }}
    />
  </svg>
);
